import { render, staticRenderFns } from "./VerifiedReportDetailsModel.vue?vue&type=template&id=3a66c57b&"
import script from "./VerifiedReportDetailsModel.vue?vue&type=script&lang=js&"
export * from "./VerifiedReportDetailsModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports